import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import moment from 'moment';
import _ from 'lodash';

import {
  EVENT_TYPES,
} from '../../hocs/data/with-dyzio-events-data';

const Link = ({ href, label }) => (
  <a
    target="_blank"
    rel="noopener noreferrer"
    href={href}
  >{label}</a>
);

Link.propTypes = {
  href: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

const {
  INFLUENCER_CREATED,
  CAMPAIGN_CREATED,
  SHORTLIST_CREATED,
  TRACKED_ASSED_CREATED,
} = EVENT_TYPES;


const TableRowLink = ({
  eventName,
  messageData,
}) => {
  const linkComponents = {};
  linkComponents[INFLUENCER_CREATED] = (<Link
    href={`/influencer/${_.get(messageData, 'resource.id')}/latest`}
    label="view influencer"
  />);
  linkComponents[CAMPAIGN_CREATED] = (<Link
    href={`/campaign/${_.get(messageData, 'resource.id')}`}
    label="view campaign"
  />);
  linkComponents[SHORTLIST_CREATED] = (<Link
    href={`/shortlists/${_.get(messageData, 'resource.id')}`}
    label="view shortlist"
  />);
  linkComponents[TRACKED_ASSED_CREATED] = (<Link
    href={_.get(messageData, 'resource.assetURL')}
    label={_.get(messageData, 'resource.assetURL')}
  />);
  const component = linkComponents[eventName] || null;
  return component;
};

const AuditLogTableRow = ({
  createdDate,
  createdBy,
  messageData,
  eventName,
  message,
}) => (
  <Table.Row>
    <Table.Cell>
      { moment(createdDate).utc().format() }
    </Table.Cell>
    <Table.Cell>
      { createdBy }
    </Table.Cell>
    <Table.Cell>
      { message }
    </Table.Cell>
    <Table.Cell>
      { _.get(messageData, 'resource.campaignName', '-') }
    </Table.Cell>
    <Table.Cell>
      <TableRowLink
        messageData={messageData}
        eventName={eventName}
      />
    </Table.Cell>
  </Table.Row>
);

AuditLogTableRow.propTypes = {
  createdDate: PropTypes.string.isRequired,
  createdBy: PropTypes.string.isRequired,
  messageData: PropTypes.object.isRequired,
  eventName: PropTypes.oneOf([...EVENT_TYPES]).isRequired,
  message: PropTypes.string.isRequired,
};

AuditLogTableRow.defaultProps = {
  message: '-',
};

export default AuditLogTableRow;



/** WEBPACK FOOTER **
 ** ./src/components/audit-log-table-row/index.js
 **/